// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.none[data-v-4c0c6b47] {\r\n  border: none;\r\n  width: 100%;\n}\n.success[data-v-4c0c6b47] {\r\n  border: none;\r\n  border-top: 0.05rem solid #2db782;\r\n  width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
